<template>
  <v-card width="150" align="center" justify="center" class="quick-menu">
    <i-btn
      elevation="0"
      color="primary"
      outlined
      class="btn-mypage"
      @click="goMyPage"
      ><v-icon class="material-icons-outlined"> account_circle </v-icon
      >마이페이지</i-btn
    >
    <div class="remain-time" v-if="!isReadonly">
      <span class="inner-wrap float-left">
        <v-icon class="material-icons-outlined">alarm</v-icon>
        <span class="time">{{ minutes + ':' + seconds }}</span>
      </span>
      <i-btn color="primary" small class="float-right" @click="reset"
        >연장</i-btn
      >
    </div>
    <div class="title" align="left">
      <span>
        {{ $t('작성항목') }}
      </span>
    </div>
    <vue-custom-scrollbar class="modal-scroll scroll">
      <ul align="left" class="menu-list" v-if="items && items.length > 0">
        <li v-for="item in items" :key="'menu-' + item.key">
          <a class="nav-link" :href="'#nav-' + item.key">{{
            $t(item.title)
          }}</a>
        </li>
      </ul>
    </vue-custom-scrollbar>
    <div class="btn-wrap mt-4" v-if="!isReadonly">
      <i-btn elevation="0" color="primary" @click="save"
        ><v-icon class="material-icons-outlined">check</v-icon
        >{{ $t('지원서 제출') }}</i-btn
      >
    </div>
  </v-card>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';

export default {
  mixins: [DialogMixin],
  props: {
    titles: { type: Array },
    template: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  computed: {
    minutes: function() {
      const m = String(Math.floor(this.time / 60));
      return m.padStart(2, '0');
    },
    seconds: function() {
      const s = String(this.time - this.minutes * 60);
      return s.padStart(2, '0');
    },
  },
  data: () => ({
    items: [],
    timer: null,
    time: 0,
    baseTime: 30 * 60,
  }),
  methods: {
    setting: function() {
      if (this.titles && this.template) {
        var $this = this;
        this.titles.forEach(function(v) {
          var key = v;
          var code = $this.recapitalize(v.replace('type', '')) + 'Title';

          if ($this.template.hasOwnProperty(code)) {
            let item = {
              key: key,
              title: $this.template[code],
            };
            $this.items.push(item);
          } else if (key === 'typeSelfIntro') {
            let item = {
              key: key,
              title: this.$t('자기소개서'),
            };
            $this.items.push(item);
          } else if (key == 'typeFile') {
            let item = {
              key: key,
              title: this.$t('첨부파일'),
            };
            $this.items.push(item);
          } else if (key == 'typeCustom') {
            let item = {
              key: key,
              title: this.$t('부가정보'),
            };
            $this.items.push(item);
          }
        });

        if (!this.isReadonly) this.start();
      }
    },
    start: function() {
      this.time = this.baseTime;
      this.timer = setInterval(() => this.countdown(), 1000);
    },
    reset: function() {
      clearInterval(this.timer);
      this.timer = null;
      this.start();
    },
    countdown: function() {
      if (this.time >= 1) {
        this.time--;
      } else {
        clearInterval(this.timer);
        this.goMyPage();
      }
    },
    recapitalize: function(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    goMyPage: function() {
      this.$router.push('/console/' + this.$route.params.tenantKey);
    },

    save() {
      this.$emit('saveConfirm');
    },
  },
};
</script>

<style scoped lang="scss">
.scroll {
  max-height: 400px;
  position: relative;
}
.quick-menu {
  position: fixed;
  top: 26.5%;
  right: 50%;
  z-index: 1;
  padding: 10px;
  margin: 32px -650px 0 0;
}
.quick-menu .btn-mypage .v-icon {
  margin-right: 4px;
  font-size: 14px;
}
.quick-menu .remain-time {
  padding: 10px 10px;
  margin-top: 10px;
  margin-left: -10px;
  margin-right: -10px;
  background: #eef4f8;
  color: #0065bd;
  border-bottom: 1px solid #dedede;
}
.quick-menu .remain-time::after {
  content: '';
  width: 100%;
  display: table;
}
.quick-menu .remain-time .v-icon {
  margin-top: -5px;
  margin-right: 3px;
  font-size: 20px;
  color: #0065bd;
}
.quick-menu .remain-time .time {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  letter-spacing: -0.36px;
  color: #0065bd;
}
.quick-menu .title {
  padding: 10px 0px 0px 24px;
  margin: 0px -10px;
  border-bottom: 1px solid #f6f6f6;
  font-size: 12px !important;
  font-weight: bold;
  color: #637887 !important;
  letter-spacing: -0.24px !important;
}
.quick-menu .menu-list {
  list-style: none;
}
.quick-menu .menu-list li {
  margin-bottom: 8px;
  a.nav-link:hover {
    color: #0065bd !important;
  }
}
.quick-menu .menu-list li:first-child {
  margin-top: 5px;
}
.quick-menu .menu-list a {
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.28px;
  color: #292929;
}
.quick-menu .btn-wrap button {
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.28px;
  // color: #0065bd;
}
.quick-menu .btn-wrap button .v-icon {
  margin-right: 4px;
  font-size: 18px;
}

@media screen and (max-height: 935px) {
  .quick-menu {
    top: 10%;
  }
}

@media screen and (max-height: 850px) {
  .quick-menu {
    top: 7.5%;
  }
}
</style>
